import axios, {AxiosError, AxiosRequestConfig} from 'axios';
import {BaseQueryFn} from '@reduxjs/toolkit/query';
import queryString from 'query-string';

export const axiosBaseQuery =
    (
        {baseUrl, paramsSerializer}: { baseUrl: string, paramsSerializer?: (params: any) => string } = {baseUrl: '', paramsSerializer: (params) => queryString.stringify(params, {arrayFormat: 'none'})}
    ): BaseQueryFn<
        {
            url: string;
            method: AxiosRequestConfig['method'];
            data?: AxiosRequestConfig['data'];
            params?: AxiosRequestConfig['params'];
            headers?: AxiosRequestConfig['headers'];
            config?: AxiosRequestConfig;
        },
        unknown,
        unknown
    > =>
        async ({url, method, data, params, headers, config}) => {
            try {
                const result = await axios({url: baseUrl + url, method, params, data, headers, paramsSerializer, ...config});
                return {data: result.data, meta: {headers: result.headers}};
            } catch (axiosError) {
                let err = axiosError as AxiosError;
                return {
                    error: {status: err.response?.status, data: err.response?.data},
                };
            }
        };
